// Copyright © Veeam Software Group GmbH
/* eslint-disable */
// Autogenerated

export enum M365BackupPolicyStatus {
}
